export default "__VITE_ASSET__mQEV3pvw__"